'use client';

import Link from 'next/link';
import { useActionState } from 'react';
import { entrar } from '@/lib/acoes-acesso';
import { Entrada, Rotulo } from '@/components/ui/Campo';
import { BotaoEnviar, Alerta } from '@/components/ui/Formulario';

export default function PaginaEntrar() {
  const [estado, acao] = useActionState(entrar, undefined);

  return (
    <div className="w-full max-w-sm rounded-xl border border-gray-200 bg-white p-6 shadow-sm">
      <h1 className="text-xl font-bold text-gray-900">Entrar</h1>
      <p className="mt-1 text-sm text-gray-500">Acesse o painel do seu workspace.</p>

      <form action={acao} className="mt-6 space-y-4">
        <Alerta mensagem={estado?.erro} />
        <div>
          <Rotulo htmlFor="email">E-mail</Rotulo>
          <Entrada id="email" name="email" type="email" autoComplete="email" required />
        </div>
        <div>
          <Rotulo htmlFor="senha">Senha</Rotulo>
          <Entrada id="senha" name="senha" type="password" autoComplete="current-password" required />
        </div>
        <BotaoEnviar carregando="Entrando...">Entrar</BotaoEnviar>
      </form>

      <p className="mt-5 text-center text-sm text-gray-500">
        Ainda não tem conta?{' '}
        <Link href="/cadastrar" className="font-medium text-indigo-600 hover:underline">
          Criar conta
        </Link>
      </p>
    </div>
  );
}
